class AuthDeviceResource {
    public static $inject: string[] = ["$resource", "configService"];

    constructor($resource: ng.resource.IResourceService, configService) {
        return headers => {
            return $resource(configService.authApi.url, { active: "@active", deviceId: "@deviceId" }, {
                getAccessToken: {
                    method: "GET",
                    url: `${configService.authApi.url}/v1/auth/access`,
                    // url: `${configService.authApi.url}/v1/devices/access`,
                    headers: headers || {}
                },
                query: {
                    method: "GET",
                    isArray: true,
                    url: `${configService.authApi.url}/v1/admin/device`,
                    // url: `${configService.authApi.url}/v1/devices`,
                    headers: headers || {}
                },
                revoke: {
                    method: "POST",
                    url: `${configService.authApi.url}/v1/admin/revoke`,
                    // url: `${configService.authApi.url}/v1/devices/revoke`,
                    // url: `${configService.authApi.url}/v1/devices/:id`, // (PATCH)
                    headers: headers || {}
                },
                postScopes: {
                    method: "POST",
                    url: `${configService.authApi.url}/v2/devices/:deviceId/scopes`,
                    headers: headers || {}
                },
                deleteScopes: {
                    method: "DELETE",
                    url: `${configService.authApi.url}/v2/devices/:deviceId/scopes`,
                    headers: { "content-type": "application/json;charset=utf-8" },
                    hasBody: true,
                    isArray: true
                }
            });
        };
    }
}

angular
    .module("thor.core.auth.device.resource", [])
    .factory("authDeviceResource", AuthDeviceResource);
